exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fixed-position {\n  position: fixed;\n  top: 2;\n  z-index: 10;\n  margin-top: -50px !important;\n}\n\n  /* Apply media query for mobile view */\n@media screen and (max-width: 767px) {\n.home-vue-content .home-advance-filters {\n    width: 100% !important;\n    margin: 0 auto !important;\n    display: flex;\n}\n\n  /* When the element is fixed, unset the margin auto */\n.home-vue-content .home-advance-filters.fixed-position {\n    margin-top: -50px !important;\n    width: 100% !important;\n    display: flex !important;\n}\n}\n", ""]);

// exports
